// extracted by mini-css-extract-plugin
export var noSpinners = "_sr-6";
export var percentageInput = "_sr-7";
export var variantColor1 = "_sr-0";
export var variantColor2 = "_sr-1";
export var variantColor3 = "_sr-2";
export var variantColor4 = "_sr-3";
export var variantColor5 = "_sr-4";
export var variantColor6 = "_sr-5";